// extracted by mini-css-extract-plugin
export default {"RoomCountBody":"styles_RoomCountBody__+zOm5","title":"styles_title__HiLM7"};